import React, { useEffect, useRef, useState } from 'react';
import { getFormattedAmount } from '@zonofi/common';
import { SVGS } from '@zonofi/zono-money-design-system';
import './weighted-price-info.scss';

interface WeightedPriceInfoProps {
  weightedPrice?: number;
}

export const WeightedPriceInfo: React.FC<WeightedPriceInfoProps> = ({
  weightedPrice,
}) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (!wrapperRef.current?.contains(event.target as Node)) {
        setIsTooltipOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  return (
    <div
      className="weighted-price-info"
      ref={wrapperRef}
      role="button"
      tabIndex={0}
      aria-label="Show weighted price info"
      aria-expanded={isTooltipOpen}
      onClick={(event) => {
        event.stopPropagation();
        setIsTooltipOpen((prev) => !prev);
      }}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          event.stopPropagation();
          setIsTooltipOpen((prev) => !prev);
        }
      }}
    >
      <span className="weighted-price-info-value">
        {` • `}
        <span className="weighted-price-info-bracket">(</span>
        <span className="weighted-price-info-text">
          {getFormattedAmount(weightedPrice ?? 0) ?? 0}
        </span>
        <span className="weighted-price-info-bracket">)</span>
      </span>
      <img src={SVGS.InfoIconBlack} alt="" width={15} height={15} />
      {isTooltipOpen && (
        <span
          className="weighted-price-info-tooltip font-primary"
          role="tooltip"
          onClick={(event) => event.stopPropagation()}
        >
          <span className="weighted-price-info-tooltip-content">
            <span className="weighted-price-info-tooltip-icon">
              <img src={SVGS.InfoIconBlack} alt="" width={16} height={16} />
            </span>
            <span className="weighted-price-info-tooltip-text">
              Computed Price <br />
              {`weight x price = ${getFormattedAmount(weightedPrice ?? 0) ?? 0}`}
            </span>
          </span>
        </span>
      )}
    </div>
  );
};
